export async function temporaryDisabled() {
  return {
    disabled: true,
    totalError: 0,
    error: 'Momentáneamente carga de datos deshabilitada',
  }
}
